import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../i18n/LanguageContext";
import { IMAGES } from "../lib/site";

const GalleryItem = ({ src, className, index }) => (
  <motion.div
    initial={{ opacity: 0, scale: 0.95 }}
    whileInView={{ opacity: 1, scale: 1 }}
    viewport={{ once: true, amount: 0.1 }}
    transition={{ duration: 0.6, delay: index * 0.06 }}
    className={`relative overflow-hidden rounded-sm border border-white/10 group ${className}`}
    data-testid={`gallery-item-${index}`}
  >
    <img
      src={src}
      alt={`Gallery ${index + 1}`}
      loading="lazy"
      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
  </motion.div>
);

const Gallery = () => {
  const { t } = useLang();
  const imgs = IMAGES.gallery;

  // Bento layout slots — each entry maps to one image index from IMAGES.gallery
  const slots = [
    { src: imgs[0], cls: "col-span-2 md:col-span-7 row-span-2" },
    { src: imgs[1], cls: "col-span-2 md:col-span-5 row-span-1" },
    { src: imgs[2], cls: "col-span-1 md:col-span-3 row-span-1" },
    { src: imgs[3], cls: "col-span-1 md:col-span-2 row-span-1" },
    { src: imgs[4], cls: "col-span-2 md:col-span-5 row-span-2" },
    { src: imgs[5], cls: "col-span-1 md:col-span-4 row-span-1" },
    { src: imgs[6], cls: "col-span-1 md:col-span-3 row-span-1" },
  ].filter((s) => Boolean(s.src));

  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative py-24 md:py-36 bg-black border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 mb-12">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-gold" />
              <span className="label-eyebrow text-gold">{t.gallery.eyebrow}</span>
            </div>
            <h2 className="font-display uppercase text-4xl md:text-5xl lg:text-6xl tracking-tighter leading-[0.95]">
              {t.gallery.title}
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-12 gap-4 md:gap-5 auto-rows-[140px] md:auto-rows-[180px]">
          {slots.map((s, i) => (
            <GalleryItem key={i} src={s.src} className={s.cls} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
